import { AttentionMessage, Flex, useIsMobile } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { EastingNorthing } from 'pages';
import { useTranslation } from 'react-i18next';
import { GetCaseDetailsResponse } from 'types';

export const NoMapData: React.FC<{ caseDetails?: GetCaseDetailsResponse }> = ({
  caseDetails,
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation('case_details_map');

  return (
    <>
      <AttentionMessage
        status='info'
        title={t('no_map_polygon_data', 'No site polygon available.')}
        variant='inline'
        color={COLOURS.black}
        mb={4}
      />
      {isMobile && (
        <Flex justifyContent='start' mb={4}>
          <EastingNorthing caseDetails={caseDetails} />
        </Flex>
      )}
    </>
  );
};
